var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.128906,
    width: 25.0606,
    height: 25,
    fill: "url(#pattern0_907_6221)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_907_6221",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_907_6221",
    transform: "matrix(0.0332527 0 0 0.0333333 0.0012098 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_907_6221",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrklEQVR4nO2VzUrDQBDHV8huRU+CFW/ehcxGKh6kHjwIFkEQ1Jtn9eoLVJqZFryJl3oT8Ulsz9VnUO9q8SB+pLJpkE36kdQkirQDA2V2Or/MfzYTxv6DTUJxhgOhALoREl88b3BAW52lAhUW7giJTSGp1d2xKUzaTgPq6KDvMz/c+RFcSNzgQA9uEcC6iikJ/Z2iIwAvtP9c+h4K6JlZlHXPAOsqxiXeCxMLPcFuglfAADxwY2qmWldcUsmNm5WcsYCL7Ry0u+UYQIda7K5Px34Zvae+1Ysalr3MWGusrQw6XNKpALoKSN4IqxsODl4osI/cg7nieEbSqtst4FPwoqUApncBWBVmeZOZlSmVk7FoLXkw+KXmQGcC6NwDvLJccXpi/mQ2cam5pJIfXN5TcUPiUnve6jftBy7XcWwwsyjrmyHgm+paU6QqAD+0UTwqFeKDmTvnLSHpM8oC4ZJ2o9aNAKZa71XZ4bU/AuN1YuC4NgL3lCQtZ2GziOJqeRhg5xMBc+2zGAoGO2+YtBI1n/f9LJpYGAQ+CDQD5fXB34ehMxFzZf4SuHNljmw47QvLkCzOu91QWAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/market-icon.799534345ae2ef43a6c49d7d8b581d5e.svg";
export { ForwardRef as ReactComponent };